import React from 'react';

import styles from './AuctionCard.module.css';

interface Props {
  className?: string;
}

export const AuctionCard: React.FC<Props> = props => {
  const newClassName =
    props.className != null ? `${props.className} ${styles.card}` : styles.card;
  return <div className={newClassName}>{props.children}</div>;
};
